import React, { useEffect } from 'react';
import loadUserInfo from './boot/loadUserInfo';
import loadManifest from '../../apps/manifest/loadManifest';
import useProvider from './useProvider';
import store from '../../store';

var useRefreshAuth = function useRefreshAuth() {
  var _useProvider = useProvider(),
      microservice = _useProvider.microservice,
      routes = _useProvider.routes;

  useEffect(function () {
    var timer = setTimeout(function () {
      store.dispatch(loadUserInfo({
        routes: routes,
        microservice: microservice.id
      }));
      store.dispatch(loadManifest({
        microservice: microservice.id
      }));
    }, 3000);
    return function () {
      return clearTimeout(timer);
    };
  }, []);
};

export default useRefreshAuth;